import createApiClient from "./api";

const api = createApiClient();

export const fetchDashboard = async (projectId) => {
  const response = await api.get(`/dashboard?project_id=${projectId}`);
  return response.data;
};

export const fetchHealthReport = async () => {
  const response = await api.get("/dashboard/health-report");
  return response.data;
};
